import { ClientBrandCode, RequestAction } from '@domgen/dgx-fe-common';
import { RegistrationFeatures } from './registration-features.type';
import { RegistrationPartsWarranty } from './registration-parts-warranty.interface';

export interface RegistrationConfig {
  applianceMaximumAgeInMonths: number;
  applianceRegistrationLimit: number;
  clientBrandCode?: ClientBrandCode;
  commonApi: string;
  defaultApplianceCategoryCode?: string;
  defaultWarranty?: Record<string, number>;
  features: RegistrationFeatures;
  modelNumberSearchEnabledBrands: ClientBrandCode[];
  partsWarranty?: Record<string, RegistrationPartsWarranty>;
  requestAction?: RequestAction;
  retailerFieldEnabledBrands: ClientBrandCode[];
  serializationApi?: string;
  warrantyMaximumLengthInMonths?: number;
}
